import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { lazyInject } from '../../ioc';
import { RouteParams as RouteParamsBase } from '../estimate-routes';
import { EstimateStore } from '../../stores/estimate.store';
import { Estimate } from 'src/api';
import { Terms } from './desktop/terms';
import { UIStatusStore } from 'src/core/stores/ui-status.store';

type RouteParams = Required<RouteParamsBase>;

@observer
export class TermsContainer extends React.Component<RouteComponentProps<RouteParams>> {
    @lazyInject(EstimateStore) estimateStore!: EstimateStore;
    @lazyInject(UIStatusStore) uiStatusStore!: UIStatusStore;

    @observable estimate: Estimate | undefined;
    @observable bundleId: string;
    @observable estimateId: string;
    @observable termsHtml: string = '';
    @observable isSignEstimateOpen = false;

    constructor(props: RouteComponentProps<RouteParams>) {
        super(props);
        this.bundleId = props.match.params.bundleId;
        this.estimateId = props.match.params.estimateId;
        if (this.estimateStore.estimateBundle) {
            this.estimate = this.estimateStore.estimateBundle.estimates.find(
                (e) => e.id === this.estimateId
            );
            this.termsHtml = this.getTermsHtml(this.estimate);
        }
        if (!this.estimate) {
            this.estimateStore.gotoEstimate(this.estimateId, props.match.params.bundleId, true);
            return;
        }
    }

    getTermsHtml = (estimate: Estimate | undefined) => {
        let terms = (estimate && estimate.termsSanitized) || '';
        if (estimate && estimate.termsFileName) {
            terms = terms.replace(
                '{Terms}',
                `<a href="/api/invoices/agreement?fileName=${estimate.termsFileName}" target="_blank">Terms and Conditions</a>` // tslint:disable ter-max-len
            );
        } else {
            terms = terms.replace('{Terms}', 'Terms and Conditions');
        }
        return terms;
    };

    showSignEstimate = () => {
        this.isSignEstimateOpen = true;
    };

    closeSignEstimate = () => {
        this.isSignEstimateOpen = false;
    };

    render() {
        return <Terms container={this} />;
    }
}
